// extracted by mini-css-extract-plugin
module.exports = {"title":"_3ubfIEGRCyVQRfx4dlR5Ts"};